import { parseFlights } from '@augloop/workflow-flights';
var LocalWorkflowContext = /** @class */ (function () {
    function LocalWorkflowContext(params) {
        this.model = params.model;
        this.clientMetadata = params.clientMetadata;
        this.site = params.site;
        this.getToken = params.getTokenCallback;
    }
    Object.defineProperty(LocalWorkflowContext.prototype, "flights", {
        get: function () {
            var _a;
            (_a = this._flights) !== null && _a !== void 0 ? _a : (this._flights = parseFlights(this.clientMetadata.flights));
            return this._flights;
        },
        enumerable: false,
        configurable: true
    });
    LocalWorkflowContext.prototype.getToken = function (tokenType, cb) {
        return this.getToken(tokenType, cb);
    };
    return LocalWorkflowContext;
}());
export { LocalWorkflowContext };
//# sourceMappingURL=local-workflow-context.js.map